import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

// Material 14 always started the week on Sunday; since v15 it follows the locale (en-GB starts on Monday).
@Injectable()
export class LegacyDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 0;
  }
}
